import React from 'react'
import { Box } from '@mui/material'

import { NotionPagination } from '@/apps/latest/components/portal/notion'

interface PaginationControlProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const PaginationControl: React.FC<PaginationControlProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 1) {
    return null
  }

  const handleChange = (_: React.ChangeEvent<unknown>, page: number) => {
    onPageChange(page)
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
      <NotionPagination
        count={totalPages}
        page={currentPage}
        onChange={handleChange}
        showFirstButton
        showLastButton
        siblingCount={1}
        boundaryCount={1}
      />
    </Box>
  )
}

export default PaginationControl
